import React from 'react';
import { SwiperSlide } from 'swiper/react';
import { CarrouselWrapper, Section } from './SectionSimilars.styles';
import { Title } from '@/components/typography';
import { Container } from '@/components/container';
import CardProductVertical from '@/features/pacote/components/CardProductVertical/CardProductVertical';
import CarrouselFeatured from '@/components/carrousel/CarrouselFeatured';

export interface CarrouselPackagesProps {
  title: string;
  similar: PacoteItinerarySimilarType[];
}

const SectionSimilars = ({ title, similar }: CarrouselPackagesProps) => {
  return similar && similar.length ? (
    <Section>
      <Container>
        <Title as="h2" weight="black" size="2xl" color="secondary_500">
          {title}
        </Title>

        <CarrouselWrapper>
          <CarrouselFeatured slidesPerView={3} minHeight="40rem">
            {similar.map((pacote, index) => (
              <SwiperSlide key={`${pacote.uuid}-${index}`}>
                <CardProductVertical {...pacote} />
              </SwiperSlide>
            ))}
          </CarrouselFeatured>
        </CarrouselWrapper>
      </Container>
    </Section>
  ) : null;
};

export default SectionSimilars;
